export interface RecommendedTranslationWorkflowPolicy {
  modelId: string
  name: 'legacy' | 'validated' | string
  reasoning_effort?: string | null
  implicit_proofreader?: boolean
  validation_enabled?: boolean
  final_alignment_enabled?: boolean
  proofreaderMode?: 'included' | 'optional'
  recommendedCopyVariant?: 'legacy_included_proofreader' | 'validated_optional_proofreader' | string
}

const configuredPolicy = process.env.REACT_APP_RECOMMENDED_TRANSLATION_POLICY
const preparedForValidatedWorkflow = ['validated', 'terra', 'sol'].includes(configuredPolicy || '')

export const DEFAULT_RECOMMENDED_TRANSLATION_POLICY: RecommendedTranslationWorkflowPolicy = preparedForValidatedWorkflow
  ? {
      modelId: 'GPT6Sol',
      name: 'validated',
      reasoning_effort: 'low',
      implicit_proofreader: false,
      validation_enabled: true,
      final_alignment_enabled: true,
      proofreaderMode: 'optional',
      recommendedCopyVariant: 'validated_optional_proofreader',
    }
  : {
      modelId: 'Gemini3Flash',
      name: 'legacy',
      implicit_proofreader: true,
      validation_enabled: true,
      final_alignment_enabled: true,
      proofreaderMode: 'included',
      recommendedCopyVariant: 'legacy_included_proofreader',
    }

export const DEFAULT_RECOMMENDED_TRANSLATION_MODEL_ID =
  DEFAULT_RECOMMENDED_TRANSLATION_POLICY.modelId
